import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=c4ad6ab6&scoped=true"
import script from "./guide.vue?vue&type=script&lang=js"
export * from "./guide.vue?vue&type=script&lang=js"
import style0 from "./guide.vue?vue&type=style&index=0&id=c4ad6ab6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ad6ab6",
  null
  
)

export default component.exports